<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t('commonMsg.new') }}</span>
      <span v-else>{{ $t('commonMsg.edit') }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          :model="server"
          @submit.native.prevent
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item :label="$t('server.name')" prop="name">
            <el-input
              v-model="server.name"
              class="fl"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="内测设备(多设备用\隔开)" prop="testMac">
            <el-input
              v-model="testMac"
              class="fl"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否禁用">
            <el-radio-group v-model="server.disable">
              <el-radio label="yes">禁用</el-radio>
              <el-radio label="no">开放</el-radio>
              <el-radio label="test">内测</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="接口版本">
            <el-radio-group v-model="server.apiVersion">
              <el-radio label="v1">v1</el-radio>
              <el-radio label="v2">v2</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('server.lang')" prop="lang">
            <el-input
              v-model="server.lang"
              class="fl"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('server.langGroup')">
            <div
              class="parms-list"
              v-for="(item, index) in langParams"
              :key="index"
            >
              <el-input v-model="item.key" clearable placeholder="语言是什么" />
              <el-input
                v-model="item.value"
                clearable
                placeholder="显示的名字是什么"
              />
              <span
                v-if="index === langParams.length - 1"
                @click="addLangParam"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteParam(langParams, item.id)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>

          <el-form-item :label="$t('server.region')" prop="region">
            <el-input
              v-model="server.region"
              clearable
              class="fl"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="禁用IP" prop="serverIp">
            <div>
              <el-checkbox-group v-model="server.neCountrys">
                <el-checkbox
                  v-for="item in serverIpOpt"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="IP白名单">
            <div
              class="parms-list"
              v-for="(item, index) in ipWhiteArr"
              :key="index"
            >
              <el-input v-model="item.value" clearable placeholder="输入IP" />
              <span
                v-if="index === ipWhiteArr.length - 1"
                @click="addIpWhiteArr"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteIpWhiteArr(index)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>
          <el-form-item label="测试组" prop="modelGroups">
            <div>
              <el-checkbox-group v-model="server.testMacGroups">
                <el-checkbox
                  v-for="item in macData"
                  :key="item._id"
                  :label="item._id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="禁用型号" prop="modelGroups">
            <div>
              <el-checkbox-group v-model="server.neModelGroups">
                <el-checkbox
                  v-for="item in modelData"
                  :key="item._id"
                  :label="item._id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="允许型号" prop="modelGroups">
            <div>
              <el-checkbox-group v-model="server.allowModelGroups">
                <el-checkbox
                  v-for="item in modelData"
                  :key="item._id"
                  :label="item._id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item :label="$t('server.host')">
            <div
              class="parms-list"
              v-for="(item, index) in params"
              :key="index"
            >
              <el-input v-model="item.key" clearable placeholder="域名名" />
              <el-input v-model="item.value" clearable placeholder="域名值" />
              <span
                v-if="index === params.length - 1"
                @click="addParam"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteParam(params, item.id)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('server.ossConfig')">
            <div
              class="parms-list"
              v-for="(item, index) in ossParams"
              :key="index"
            >
              <el-input v-model="item.key" clearable placeholder="项" />
              <el-input v-model="item.value" clearable placeholder="值" />
              <span
                v-if="index === ossParams.length - 1"
                @click="addOssParam"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteParam(ossParams, item.id)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {
    serverIpOpt() {
      return [
        {
          label: '中国',
          value: 'CN'
        },
        {
          label: '美国',
          value: 'US'
        },
        {
          label: '俄罗斯',
          value: 'RU'
        },
        {
          label: '德国',
          value: 'DE'
        },
        {
          label: '越南',
          value: 'VN'
        },
        {
          label: '香港',
          value: 'HK'
        },
        {
          label: '台湾',
          value: 'TW'
        },
        {
          label: '日本',
          value: 'JP'
        }
      ]
    }
  },
  data() {
    let checkRegion = (rule, value, callback) => {
      let regs = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/
      if (value === '') {
        callback(new Error(this.$t('server.inputRegion')))
      } else if (!regs.test(value)) {
        callback(new Error(this.$t('server.errDomain')))
      } else {
        callback()
      }
    }
    return {
      ipWhiteArr: [{ value: '' }],
      modelData: [],
      macData: [],
      testMac: '',
      server: {
        name: '',
        lang: '',
        testMac: [],
        host: {},
        langGroup: {},
        region: '',
        ossConfig: {},
        apiVersion: 'v1',
        disable: 'no',
        neModelGroups: [],
        allowModelGroups: [],
        testMacGroups: [],
        neCountrys: [],
        ipWhite: []
      },
      rules: {
        name: [
          {
            required: true,
            message:
              '输入默认名字，设备的语言在多语言匹配不到，就会显示默认名字',
            trigger: 'blur'
          }
        ],
        lang: [
          {
            required: true,
            message: '输入语言简称，用于国内服务器zh显示京东书城',
            trigger: 'blur'
          }
        ],
        region: [
          {
            required: true,
            message: this.$t('server.inputRegion'),
            trigger: 'blur'
          }
        ]
      },
      params: [
        {
          id: String(Math.random()).substring(2, 12),
          key: '',
          value: ''
        }
      ],
      langParams: [
        {
          id: String(Math.random()).substring(2, 12),
          key: '',
          value: ''
        }
      ],
      ossParams: [
        {
          id: String(Math.random()).substring(2, 12),
          key: '',
          value: ''
        }
      ]
    }
  },
  methods: {
    getModelGroups() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getModelGroups()
          this.modelData = res.data.results
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    },
    getMacGroups() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getMacGroups({
            limit: 10000,
            page: 1
          })
          this.macData = res.data.results
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    },
    getAppDetails() {
      this.$http.getServerDetails(this.$route.query.id).then((ret) => {
        let params = []
        for (let key in ret.data.host) {
          let obj = {
            id: String(Math.random()).substring(2, 12),
            key: key,
            value: ret.data.host[key]
          }
          params.push(obj)
        }

        if (params.length === 0) {
          let headerObj = {
            id: String(Math.random()).substring(2, 12),
            key: '',
            value: ''
          }
          params.push(headerObj)
        }
        this.params = params

        let ossParams = []
        for (let key in ret.data.ossConfig) {
          let obj = {
            id: String(Math.random()).substring(2, 12),
            key: key,
            value: ret.data.ossConfig[key]
          }
          ossParams.push(obj)
        }

        if (ossParams.length === 0) {
          let ossObj = {
            id: String(Math.random()).substring(2, 12),
            key: '',
            value: ''
          }
          ossParams.push(ossObj)
        }
        this.ossParams = ossParams

        let langParams = []
        for (let key in ret.data.langGroup) {
          let obj = {
            id: String(Math.random()).substring(2, 12),
            key: key,
            value: ret.data.langGroup[key]
          }
          langParams.push(obj)
        }

        if (langParams.length === 0) {
          let ossObj = {
            id: String(Math.random()).substring(2, 12),
            key: '',
            value: ''
          }
          langParams.push(ossObj)
        }
        this.langParams = langParams

        if (ret.data.ipWhite && ret.data.ipWhite.length) {
          let ipWhiteArr = []
          for (let item of ret.data.ipWhite) {
            ipWhiteArr.push({ value: item })
          }
          if (ipWhiteArr.length === 0) {
            ipWhiteArr = [{ value: '' }]
          }
          this.ipWhiteArr = ipWhiteArr
        }

        this.testMac = ret.data.testMac.join('\\')

        let macParams = this.macData.filter((item) =>
          ret.data.testMacGroups.includes(item._id)
        )
        ret.data.testMacGroups = macParams.map((item) => item._id)

        let modelParams = this.modelData.filter((item) =>
          ret.data.neModelGroups.includes(item._id)
        )

        ret.data.neModelGroups = modelParams.map((item) => item._id)

        if (ret.data.allowModelGroups && ret.data.allowModelGroups.length) {
          let allowModelParams = this.modelData.filter((item) =>
            ret.data.allowModelGroups.includes(item._id)
          )

          ret.data.allowModelGroups = allowModelParams.map((item) => item._id)
        } else {
          ret.data.allowModelGroups = []
        }

        this.server = Object.assign({}, ret.data)
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    async create() {
      let params = {}
      this.params.map((item) => {
        if (item.key) {
          params[item.key] = item.value
        }
      })
      this.server.host = Object.assign({}, params)

      let ossParams = {}
      this.ossParams.map((item) => {
        if (item.key) {
          ossParams[item.key] = item.value
        }
      })
      this.server.ossConfig = Object.assign({}, ossParams)

      let langParams = {}
      this.langParams.map((item) => {
        if (item.key) {
          langParams[item.key] = item.value
        }
      })
      let ipWhite =
        this.ipWhiteArr
          .map((item) => item.value)
          .filter((item) => item && item.trim()) || []

      this.server.testMac = this.testMac
        .split('\\')
        .filter((item) => item && item.trim())
      this.server.langGroup = Object.assign({}, langParams)
      this.server.ipWhite = JSON.parse(JSON.stringify(ipWhite))
      this.$http.createServer(this.server).then((res) => {
        this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
        this.$router.back()
      })
    },

    async edit() {
      let params = {}
      this.params.map((item) => {
        if (item.key) {
          params[item.key] = item.value
        }
      })
      this.server.host = Object.assign({}, params)

      let ossParams = {}
      this.ossParams.map((item) => {
        if (item.key) {
          ossParams[item.key] = item.value
        }
      })
      this.server.ossConfig = Object.assign({}, ossParams)

      let langParams = {}
      this.langParams.map((item) => {
        if (item.key) {
          langParams[item.key] = item.value
        }
      })
      let ipWhite =
        this.ipWhiteArr
          .map((item) => item.value)
          .filter((item) => item && item.trim()) || []
      this.server.testMac = this.testMac
        .split('\\')
        .filter((item) => item && item.trim())
      this.server.langGroup = Object.assign({}, langParams)
      this.server.ipWhite = JSON.parse(JSON.stringify(ipWhite))
      this.$http.putServer(this.$route.query.id, this.server).then((res) => {
        this.elMsg(this.$t('alertMsg.editSuccess'), 'success')
        this.$router.back()
      })
    },

    addParam() {
      let obj = {
        id: String(Math.random()).substring(2, 12),
        key: '',
        value: ''
      }
      this.params.push(obj)
    },

    addOssParam() {
      let obj = {
        id: String(Math.random()).substring(2, 12),
        key: '',
        value: ''
      }
      this.ossParams.push(obj)
    },

    addLangParam() {
      let obj = {
        id: String(Math.random()).substring(2, 12),
        key: '',
        value: ''
      }
      this.langParams.push(obj)
    },

    deleteParam(arr, id) {
      arr.map((item, i) => {
        if (item.id === id) {
          arr.splice(i, 1)
        }
      })
    },
    addIpWhiteArr() {
      let obj = { value: '' }
      this.ipWhiteArr.push(obj)
    },

    deleteIpWhiteArr(index) {
      this.ipWhiteArr.splice(index, 1)
    }
  },
  async mounted() {
    await this.getModelGroups()
    await this.getMacGroups()
    if (!this.$route.query.id) return
    this.getAppDetails()
  }
}
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      .parms-list + .parms-list {
        margin-top: 10px;
      }
      .parms-list {
        display: flex;
        > .el-input {
          width: 40%;
          max-width: 300px;
          margin-right: 10px;
        }
        > span {
          width: 30px;
          height: 35px;
          line-height: 32px;
          text-align: center;
          display: inline-block;
          font-size: 20px;
          vertical-align: bottom;
          cursor: pointer;
          color: #555;
        }
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
</style>
